import { Box, BoxProps, Image, Text } from "@chakra-ui/react";

import ErrorImage from "../../../assets/images/error-image.svg";
import InProgressImage from "../../../assets/images/in-progress-image.svg";
import SuccessImage from "../../../assets/images/success-image.svg";

interface StatusBoxProps extends BoxProps {
  title: string;
  variant: "success" | "error" | "inProgress";
  children: string;
  /**
   * @default 200px
   */
  imgSize?: number | string;
}

export default function StatusBox({
  title,
  variant,
  children,
  imgSize = "200px",
  ...rest
}: StatusBoxProps) {
  let imgSrc = "";
  if (variant === "success") {
    imgSrc = SuccessImage;
  } else if (variant === "error") {
    imgSrc = ErrorImage;
  } else {
    imgSrc = InProgressImage;
  }

  return (
    <Box p="10" {...rest}>
      <Image src={imgSrc} alt={variant} boxSize={imgSize} mx="auto" mb="4" />
      <Text
        fontSize="24px"
        lineHeight="133%"
        textAlign="center"
        fontWeight={500}
        mb={3}
      >
        {title}
      </Text>
      <Text letterSpacing="-0.12px" color="gray.200" textAlign="center">
        {children}
      </Text>
    </Box>
  );
}
